<template>
    <div class="footer">
        <slot></slot>
    </div>
</template>
<script>
export default {
    name: 'LiFaFooter',
}
</script>
<style lang="scss" scoped>

</style>

